{
    "title":"View User",
    "viewUser": {
        "firstName": 
        {
            "title":"First Name",
            "class": "col-12 lg:col-6 form-group"
        },
        "lastName":{
            "title": "Last Name",
            "class": "col-12 lg:col-6 form-group"
        },
        "email": {            
            "title":"Email",
            "class": "col-12 form-group"
        },
        "title":{
            "title": "Title",
            "class": "col-12 form-group"
        },
        "activationDate": {
            "title":"ActivationDate",
            "class":"col-12 form-group"
        },
        "lastLogin": {
            "title": "Last Login",
            "class":"col-12 "
        },
        "status": {
            "title":"Status",
            "class":"col-12 lg:col-6 form-group",
            "statusValues":["Active","Inactive"]
        },
        "username": {
            "title": "User Name",
            "class":"col-12 form-group"
        },
        "mobileNumber": {
            "title": "Mobile Number",
            "class":"col-12 form-group"
        }
    }
}